import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useModal } from '~/hooks';
import { useModalStore } from '~/store';
import ModalView from './Modal.view';

export default function Modal() {
  const {
    type,
    title,
    content,
    click,
    isOpen,
    buttonName,
    leftButtonName,
    cancelClick,
  } = useModalStore((state) => ({
    type: state.type,
    title: state.title,
    content: state.content,
    click: state.click,
    cancelClick: state.cancelClick,
    buttonName: state.buttonName,
    leftButtonName: state.leftButtonName,
    isOpen: state.isOpen,
  }));

  const { closeModal } = useModal();

  const handleLeftButton = () => {
    cancelClick?.();
    closeModal();
  };

  const handleActionButton = () => {
    click?.();
    closeModal();
  };

  const handleBackgroundClick = () => {
    closeModal();
  };

  useEffect(() => {
    if (isOpen) {
      const preventScroll = (e: Event) => e.preventDefault();

      document.addEventListener('wheel', preventScroll, { passive: false });
      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <ModalView
      type={type}
      title={title}
      content={content}
      buttonName={buttonName}
      leftButtonName={leftButtonName}
      handleActionButton={handleActionButton}
      handleLeftButton={handleLeftButton}
      handleBackgroundClick={handleBackgroundClick}
    />,
    document.body,
  );
}
